<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Product Location</h5>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b>Create New Product Location</b>
          <b-row class="mt-4">
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Product Name"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="product_name"
                  name="product_name"
                  data-vv-as="Product Name"
                  id="input-1"
                  class="form-control"
                  placeholder="Product Name"
                />
                <b-form-invalid-feedback
                  id="input-product_name-feedback"
                >{{ veeErrors.first('product_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Brief Description"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="brief_description"
                  name="brief_description"
                  data-vv-as="Brief Description"
                  id="input-1"
                  class="form-control"
                  placeholder="Brief Description"
                />
                <b-form-invalid-feedback
                  id="input-brief_description-feedback"
                >{{ veeErrors.first('brief_description') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Duration"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="duration"
                  name="duration"
                  data-vv-as="Duration"
                  id="input-1"
                  class="form-control"
                  placeholder="Duration"
                />
                <b-form-invalid-feedback
                  id="input-duration-feedback"
                >{{ veeErrors.first('duration') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Minimal Amount (Rp)"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="minimal_amount"
                  name="minimal_amount"
                  data-vv-as="Minimal Amount"
                  id="input-1"
                  class="form-control"
                  placeholder="Minimal Amount"
                />
                <b-form-invalid-feedback
                  id="input-minimal_amount-feedback"
                >{{ veeErrors.first('minimal_amount') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="2" class="text-left">
              <label class="text-danger">
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button variant="primary" class="mr-3" @click="post()" size="lg">
                Create
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{name: 'PaymentMethod'}">
                <b-button variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      payment_method_list: [],
      product_location_list: [],
      section: "",
      product_name: "",
      brief_description: "",
      duration: "",
      minimal_amount: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      modalImage: false
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("product_name", this.product_name);
          formData.append("brief_description", this.brief_description);
          formData.append("duration", this.duration);
          formData.append("minimal_amount", this.minimal_amount);
          this.$store
            .dispatch("PaymentMethodModule/postProductLocation", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "PaymentMethod" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    }
  }
};
</script>

<style>
</style>
